// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".new-request__container{position:absolute;top:0;right:0;width:100%;min-height:700px;background:#f8fafa;z-index:5}", ""]);
// Exports
module.exports = exports;
